module.exports = __webpack_public_path__ + "img/list-pattern1.96bd927.svg";